import Http from '@/common/http'
export default class Mini {
  static getList (param = {}) {
    return Http.post('/setting/mini/getList', param)
  }
  static saveMiniEvent (param = {}) {
    return Http.post('/setting/mini/saveMiniEvent', param)
  }
  static getGroupTypeList (param = {}) {
    return Http.post('/setting/mini/getGroupTypeList', param)
  }
  static getGroupList (param = {}) {
    return Http.post('/setting/mini/getGroupList', param)
  }
  static doGroupSubmit (param = {}) {
    return Http.post('/setting/mini/handleGroup', param)
  }
  static getTagList (param = {}) {
    return Http.post('/setting/mini/getTagList', param)
  }
  static getChannleList (param = {}) {
    return Http.post('/setting/mini/getChannleList', param)
  }
  static saveMiniChannle (param = {}) {
    return Http.post('/setting/mini/saveMiniChannle', param)
  }
  static getQrcode (param = {}) {
    return Http.post('/setting/mini/getQrcode', param)
  }
  static getURLSchemeList (param = {}) {
    return Http.post('/setting/mini/getURLSchemeList', param)
  }
  static createURLScheme (param = {}) {
    return Http.post('/setting/mini/createURLScheme', param)
  }
  static getURLLinkList (param = {}) {
    return Http.post('/setting/mini/getURLLinkList', param)
  }
  static createURLLink (param = {}) {
    return Http.post('/setting/mini/createURLLink', param)
  }
}
